import { useEffect, useState } from "react";

export function useColorScheme() {
  const isDark =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-color-scheme: dark)")?.matches === true;
  const [scheme, setScheme] = useState<"dark" | "light">(
    isDark ? "dark" : "light"
  );

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    ) {
      return;
    }

    const matchMedia = window.matchMedia("(prefers-color-scheme: dark)");
    if (!matchMedia || typeof matchMedia.addEventListener !== "function") {
      return;
    }
    const onChange = ({ matches }: MediaQueryListEvent) =>
      setScheme(matches ? "dark" : "light");

    matchMedia.addEventListener("change", onChange);

    return () => matchMedia.removeEventListener("change", onChange);
  }, []);

  return scheme;
}
